import React from 'react';

const version = require('../../package.json').version;
require('style/AppBar');

export default class AppBar extends React.Component {
  constructor(props) {
    super(props);
    this.logout = this.logout.bind();
  }

  logout(e) {
    e.stopPropagation();
    localStorage.removeItem("token");
    location.reload();
  }

  render() {
    let title = '';
    if (this.props.title.length > 45) {
      title = this.props.title.slice(0, 45) + '...';
    } else {
      title = this.props.title
    }
    
        return (
      <div className="AppBar">
        <div className="side">
        </div>
        <div className="middle container">
          <div style={{margin: "-8px 0"}}>
            <div style={{fontSize: '10px'}}>Flowone Setup v.{version}</div>
            <div style={{fontSize: '16px', minHeight: '18px'}} title={this.props.title}>{title}</div>
            <div style={{fontSize: '14px'}}>
              <div className="info">sw: {this.props.name}</div>
              <div className="info">version: {this.props.version}</div>
              <div className={ this.props.lifecycleOk ? "info" : "warning" }>state: {this.props.lifecycleState}</div>
              {this.props.warning && <div className="warning">{this.props.warning}</div>}
              {this.props.unreliable && <div className="warning">{this.props.unreliable}</div>}
              {this.props.weaknetwork && <div className="weaknetworkdevice">Weak Network Device</div>}
              {/*this.props.multipleclients && <div className='weaknetworkdevice'>Multiple clients open</div>*/}
            </div>
          </div>
          {this.props.controls}
        </div>
        <div className="side">
          <button type="button" onClick={this.logout}>Logout</button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/AppBar.js